module.exports = __webpack_public_path__ + "img/leaderboard.4128866f.webp";